// src/learn/LearnApp.tsx
import React, { useEffect, useMemo } from 'react';
import LearnLayout from './LearnLayout';
import LearnNotFound from './LearnNotFound';

const mdxPages = import.meta.glob('./content/**/*.mdx', { eager: true }) as Record<string, any>;

function normalize(pathname: string) {
  return (pathname.replace(/\/+$/, '') || '/').toLowerCase();
}

function routeKeyFromPath(pathname: string) {
  const p = normalize(pathname);
  if (p === '/learn') return 'index';
  if (!p.startsWith('/learn/')) return null;
  return decodeURIComponent(p.slice('/learn/'.length));
}

function findMdxModuleBySlug(slug: string) {
  const cleaned = slug.replace(/^\/+/, '').replace(/\/+$/, '') || 'index';
  const candidates = [`./content/${cleaned}.mdx`, `./content/${cleaned}/index.mdx`];

  for (const candidate of candidates) {
    if (mdxPages[candidate]) return mdxPages[candidate];
  }

  return null;
}

export default function LearnApp() {
  useEffect(() => {
    const stored = localStorage.getItem('theme');
    document.documentElement.classList.toggle('dark', stored === 'dark');
  }, []);

  const pathname = window.location.pathname;
  const slug = routeKeyFromPath(pathname);

  const mod = useMemo(() => {
    if (!slug) return null;
    return findMdxModuleBySlug(slug);
  }, [slug]);

  const Content = (mod?.default || null) as React.ComponentType | null;
  const meta = (mod?.frontmatter || mod?.meta || {}) as Record<string, any>;

  if (!slug || !Content) {
    return (
      <LearnLayout meta={{ title: 'Page not found', noindex: true }}>
        <LearnNotFound />
      </LearnLayout>
    );
  }

  return (
    <LearnLayout meta={meta}>
      <Content />
    </LearnLayout>
  );
}
